/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { ExclamationCircleOutlined } from '@ant-design/icons';
import {
  Button,
  Col,
  Form,
  Input,
  message,
  Modal,
  Radio,
  RadioChangeEvent,
  Row,
  Select,
  Tabs,
  Upload,
  UploadProps,
} from 'antd';
import { useForm, useWatch } from 'antd/lib/form/Form';
import { Fragment, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getBalance } from 'src/api/localpay';
import {
  cancelPackageAssigned,
  checkImportExcelSerial,
  checkInputListSerial,
  checkMbfCodePackageAssigned,
  createOrderAssigned,
  deletePackageAssigned,
  getDetailPackageAssigned,
  getPackageAssignedV2,
  kittingPackageAssigned,
  retryPackageAssigned,
  updatePackageAssigned,
  uploadFilePackageAssigned,
} from 'src/api/package_assigned';
import BoxWithLabel from 'src/components/BoxWithLabel/BoxWithLabel';
import ModalConfirm from 'src/components/modals/ModalComfirm';
import { useAppDispatch, useAppSelector } from 'src/redux/hook';
import { setGlobalState } from 'src/redux/slice/globalSlice';
import { setModalState } from 'src/redux/slice/modal.store';
import { setPackageAssignedState } from 'src/redux/slice/packageAssigned';
import { OrderStatusEnum } from 'src/shared/enum/package_assigned';
import { SimType } from 'src/shared/enum/sim.enum';
import {
  ICheckInputSerialParamsRequest,
  ICreateOrder,
  IOrderStatus,
  IOverFlowOrderDetailResponse,
  OrderRequest,
  OrderUpdate,
} from 'src/shared/interface/package_assigned';
import { exportExcel, formatDateTime, formatMoney, parseQueryString } from 'src/utils';
import { simTypeToText } from 'src/utils/sim.enum';
import { renderOptionSubType } from 'src/utils/subType';
import { checkEsimExpired } from '../../../../api/changeSim';
import ModalCheckEsimExpired from '../../changeSim/ModalCheckEsimExpired';
import InputCorrect from '../components/InputCorrect';
import InputError from '../components/InputError';
import useWindowSize from 'src/hooks/useWindowSize';
import { usePermission } from 'src/hooks/usePermission';

function CreateOrderPage() {
  const size = useWindowSize();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [form] = useForm();
  const watchCode = useWatch('mbfCode', form);
  const merchantInfo: string | null = localStorage.getItem('merchantInfo');
  const location = useLocation();
  const { id } = parseQueryString(location.search);
  const { refresh, order, openTabs } = useAppSelector((state) => state.global);
  const { dataSuccess, dataFailed } = useAppSelector((state) => state.packageAssigned);

  const [openModalConfirmChangeCosType, setOpenModalConfirmChangeCosType] = useState(false);

  const [openModalConfirm, setOpenModalConfirm] = useState(false);
  const [openModalConfirmKitting, setOpenModalConfirmKitting] = useState(false);
  const [openModalConfirmDelete, setOpenModalConfirmDelete] = useState(false);
  const [openModalConfirmChange, setOpenModalConfirmChange] = useState(false);
  const [openModalConfirmCancel, setOpenModalConfirmCancel] = useState(false);
  const [simType, setSimType] = useState<number>(SimType.PHYSICAL_SIM);
  const [radio, setRadio] = useState<number>(1);
  const [file, setFile] = useState<any>();
  const [isImportFile, setIsImportFile] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [statusSim, setStatusSim] = useState<string>(OrderStatusEnum.New);
  const [dataPackage, setDataPackage] = useState<IOrderStatus[]>([]);
  const [infoPackageInput, setInfoPackageInput] = useState<IOverFlowOrderDetailResponse>();
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [isOpenModalCheckEsimExpired, setIsOpenModalCheckEsimExpired] = useState(false);
  const [listEsimExpired, setListEsimExpired] = useState([]);
  const [listEsimValid, setListEsimValid] = useState([]);

  const { PERMISSIONS, hasPermission, hasAnyPermission } = usePermission();

  const items = [
    {
      label: `${radio === 1 ? 'Nhập đúng' : 'Import đúng'}`,
      key: '1',
      children: (
        <InputCorrect
          dataSuccess={dataSuccess}
          statusSim={statusSim}
          infoPackageInput={infoPackageInput}
        />
      ),
    },
    {
      label: `${radio === 1 ? 'Nhập sai' : 'Import sai'}`,
      key: '2',
      children: <InputError dataFailed={dataFailed} />,
    },
  ];

  useEffect(() => {
    const fetchBalance = async () => {
      const balanceRes = await getBalance();
      if (balanceRes) {
        dispatch(setGlobalState({ balance: balanceRes.balance }));
      }
    };
    dispatch(
      setPackageAssignedState({
        dataSuccess: id ? dataSuccess : [],
        dataFailed: id ? dataFailed : [],
      }),
    );
    dispatch(setGlobalState({ order: undefined }));
    fetchBalance();
  }, []);

  const fetchGetPackageAssigned = async (subType?: string) => {
    await getPackageAssignedV2(subType).then((res: any) => {
      if (res) {
        const dataPackage: IOrderStatus[] = [];
        res?.map((item: any) => {
          dataPackage?.push({
            label: (
              <Row gutter={16} className='border-b'>
                <Col className='break-words !whitespace-pre-line' span={10}>
                  {item?.mbfCode ?? ''}
                </Col>
                <Col className='break-words !whitespace-break-spaces' span={14}>
                  {item?.mbfName ?? ''}
                </Col>
              </Row>
            ),
            value: item.mbfCode,
            shortLabel: item.mbfName,
          });
        });
        setDataPackage(dataPackage);
      }
    });
  };

  useEffect(() => {
    const fetchDetailOrder = async () => {
      const res = await getDetailPackageAssigned(id);
      if (res) {
        if (res.fileUrl) {
          setRadio(2);
        }
        form.setFieldsValue(res);
        fetchGetPackageAssigned(res?.subType);
        setSimType(res?.simType);
        const listCheckSuccess: IOverFlowOrderDetailResponse[] = [];
        const listCheckFail: IOverFlowOrderDetailResponse[] = [];
        const listEsimValidTmp: any = [];
        res.overFlowOrderDetailResponses?.map((item: any) => {
          if (
            res.statusString === OrderStatusEnum.New ||
            res.statusString !== OrderStatusEnum.New
          ) {
            listCheckSuccess.push(item);
          } else if (item.statusString === OrderStatusEnum.Failed) {
            if (item.id) {
              const errorItem = {
                code: item.errorCode,
                message: item.errorMessage,
                serial: item.serial,
              };
              listCheckFail.push(errorItem);
            } else {
              listCheckFail.push(item);
            }
          } else {
            listCheckSuccess.push(item);
          }

          if (item?.statusString === 'New') {
            listEsimValidTmp.push(item);
          }
        });
        dispatch(setPackageAssignedState({ dataSuccess: id ? listCheckSuccess : [] }));
        if (res.statusString !== OrderStatusEnum.New) {
          dispatch(setPackageAssignedState({ dataFailed: id ? listCheckFail : [] }));
        }
        dispatch(setGlobalState({ order: res }));
        setStatusSim(res.statusString ? res.statusString.toString() : '');
        setInfoPackageInput(undefined);
        setListEsimValid(listEsimValidTmp);
      }
    };
    if (id) {
      fetchDetailOrder();
    } else {
      dispatch(setGlobalState({ order: undefined }));
      dispatch(setPackageAssignedState({ dataSuccess: [], dataFailed: [] }));
      form.resetFields();
    }

    return () => {
      setStatusSim(OrderStatusEnum.New);
      dispatch(setPackageAssignedState({ dataSuccess: [], dataFailed: [] }));
    };
  }, [id, refresh]);

  const onChangeCountSerialNumber = (e: any) => {
    if (e?.target?.value > 1000) {
      message.error('Vượt quá số lượng cho phép!');
      form.setFieldValue('countSerialNumber', null);
    }
  };

  const handleAddInput = async (isChangeData = false) => {
    if (form.getFieldValue('mbfCode')) {
      setIsImportFile(false);
      const params: ICheckInputSerialParamsRequest = {
        distributorId: merchantInfo ? JSON.parse(merchantInfo).merchantId : 0,
        startSerialNumber: form.getFieldValue('serial'),
        countSerialNumber: Number(form.getFieldValue('countSerialNumber')),
        mbfCode: form.getFieldValue('mbfCode') ?? '',
        orderId: id ? id : undefined,
        simType,
        subType: form.getFieldValue('subType'),
      };
      const res = await checkInputListSerial(params);
      if (res) {
        setInfoPackageInput({ ...res, mbfCode: res.mbfCode, price: res.price });
        if (isChangeData) {
          setRadio(1);
          dispatch(
            setPackageAssignedState({
              dataSuccess: res.simSuccess ?? [],
              dataFailed: res.simError ?? [],
            }),
          );
          setOpenModalConfirm(false);
        } else {
          if (isImportFile) {
            dispatch(
              setPackageAssignedState({
                dataSuccess: res.simSuccess ?? [],
                dataFailed: res.simError ?? [],
              }),
            );
          } else {
            //Xử lí duplicate
            const newDataSuccess: IOverFlowOrderDetailResponse[] = [...dataSuccess];
            const newDataFailed: IOverFlowOrderDetailResponse[] = [...dataFailed];
            [...res.simSuccess].forEach((item) => {
              //Trường hợp không trùng bất cứ thằng nào.
              if (!dataSuccess.some((obj) => obj.serial === item.serial)) {
                newDataSuccess.push(item);
              }
            });
            [...res.simError].forEach((item) => {
              //Trường hợp không trùng bất cứ thằng nào.
              if (!dataFailed.some((obj) => obj.serial === item.serial)) {
                newDataFailed.push(item);
              }
            });
            dispatch(
              setPackageAssignedState({
                dataSuccess: newDataSuccess,
                dataFailed: newDataFailed,
              }),
            );
          }
        }
      }
    } else {
      message.warning(`Vui lòng chọn ${!simType ? 'loại SIM' : 'gói'}!`);
    }
  };

  const handleImport = async () => {
    if (radio === 2) {
      if (form.getFieldValue('mbfCode') && file) {
        const res = await checkImportExcelSerial({
          distributorId: merchantInfo ? JSON.parse(merchantInfo).merchantId : '',
          excelFile: file.originFileObj ? file.originFileObj : file,
          mbfCode: form.getFieldValue('mbfCode') ?? '',
          orderId: id ? id : undefined,
          simType,
        });
        if (res) {
          dispatch(
            setPackageAssignedState({
              dataSuccess: res.simSuccess ?? [],
              dataFailed: res.simError ?? [],
            }),
          );
          setInfoPackageInput({ mbfCode: res.mbfCode, price: res.price, mbfName: res.mbfName });
        }

        setOpenModalConfirm(false);
      } else {
        message.warning(`Vui lòng chọn ${!simType ? 'loại SIM' : 'gói'}!`);
        // message.error('Import không thành công. Vui lòng thử lạ asd!');
      }
    } else {
      setOpenModalConfirm(true); // Hiển thị modal xác nhận
    }
    setIsImportFile(true);
  };

  const propsUpload: UploadProps = {
    beforeUpload: (file) => {
      const isExcel =
        file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      if (form.getFieldValue('mbfCode')) {
        if (!isExcel) {
          message.error(`Định dạng file không đúng`);
        }
        return isExcel || Upload.LIST_IGNORE;
      } else {
        message.warning(`Vui lòng chọn ${!simType ? 'loại SIM' : 'gói'}!`);
        return false;
      }
    },
    onChange: ({ file }) => {
      if (file.status === 'removed') {
        setFile(null);
      } else {
        file.status = 'done';
        setFile(file);
      }
    },
    //eslint-disable-next-line
    customRequest: () => {},
  };

  const handleSubmit = async () => {
    if (statusSim === OrderStatusEnum.New) {
      if ([...dataSuccess].length === 0) {
        message.error('Vui lòng import số!');
      } else {
        try {
          let getFileUrl = '';
          if (radio === 2) {
            getFileUrl = await uploadFilePackageAssigned(
              file.originFileObj ? file.originFileObj : file,
            );
          }
          const listSerial = dataSuccess.map((item) => {
            return {
              serial: item.serial ?? '',
            };
          });
          const params: ICreateOrder = {
            merchantId: merchantInfo ? JSON.parse(merchantInfo).merchantId : '',
            mbfCode: form.getFieldValue('mbfCode') ?? '',
            overFlowOrderDetailRequest: listSerial,
            createdBy: merchantInfo ? JSON.parse(merchantInfo).merchantName : '',
            fileUrl: getFileUrl ? getFileUrl : undefined,
            fileName: file ? file.name : undefined,
            simType,
            subType: form.getFieldValue('subType'),
          };

          const res = await createOrderAssigned(params);
          if (res) {
            message.success('Lưu đơn hàng thành công!');
          }
          const newPanes = openTabs.filter((pane) => pane.key !== 'order-assigned-package/create');

          dispatch(
            setGlobalState({
              activeKeyMenu: 'order-assigned-package/detail' + '?id=' + res.id,
              refresh: !refresh,
            }),
          );
          if (
            !newPanes.find((tab) => tab.key === 'order-assigned-package/detail' + '?id=' + res.id)
          ) {
            dispatch(
              setGlobalState({
                openTabs: [
                  ...newPanes,
                  {
                    label: 'Xem chi tiết gán gói',
                    children: '',
                    key: 'order-assigned-package/detail' + '?id=' + res.id,
                    closable: true,
                  },
                ],
              }),
            );
          }
          navigate(`/management/order-assigned-package/detail?id=${res.id}`);
        } catch (error) {
          navigate(`/management/order-assigned-package/list`);
        }
      }
    }
    if (statusSim === OrderStatusEnum.EDIT) {
      if (form.getFieldValue('mbfCode') && dataSuccess.length > 0) {
        const listSerial = dataSuccess.map((item) => {
          return { serial: item.serial ?? '' };
        });
        let getFileUrl = '';
        if (radio === 2 && file) {
          getFileUrl = await uploadFilePackageAssigned(
            file.originFileObj ? file.originFileObj : file,
          );
        }

        const data: OrderUpdate = {
          mbfCode: form.getFieldValue('mbfCode'),
          subType: form.getFieldValue('subType'),
          orderId: id,
          overFlowOrderDetailResponses: listSerial,
          updatedBy: merchantInfo ? JSON.parse(merchantInfo).merchantName : '',
          fileUrl: getFileUrl ? getFileUrl : order?.fileUrl,
          fileName: file ? file.name : order?.fileName,
        };
        await updatePackageAssigned(data);
        form.resetFields(['serial', 'countSerialNumber']);

        dispatch(setGlobalState({ refresh: !refresh }));
        setStatusSim(OrderStatusEnum.New);
      } else {
        message.error('Vui lòng nhập danh sách sim gán gói!');
      }
    }
  };

  const handleKittingSim = async () => {
    setIsLoadingModal(true);
    const data: OrderRequest = {
      orderId: id,
      distibutorId: merchantInfo ? JSON.parse(merchantInfo).merchantId : '',
      updatedBy: merchantInfo ? JSON.parse(merchantInfo).merchantName : '',
      simType: form.getFieldValue('simType'),
    };
    try {
      const res = await kittingPackageAssigned(data);
      if (res) {
        message.success('Gán gói thành công!');
        dispatch(setGlobalState({ refresh: !refresh }));
        setOpenModalConfirmKitting(false);
      }
    } catch (error) {
      console.log(error);
      setIsLoadingModal(false);
    }
  };

  const handleDeleteOrder = async () => {
    if (id) {
      try {
        const res = await deletePackageAssigned(id);
        if (res) {
          message.success('Xoá đơn hàng thành công!');
          const newPanes = openTabs.filter((pane) => pane.key !== 'order-assigned-package/list');
          dispatch(
            setGlobalState({
              activeKeyMenu: 'order-assigned-package/list',
            }),
          );
          if (!newPanes.find((tab) => tab.key === 'order-assigned-package/list')) {
            dispatch(
              setGlobalState({
                openTabs: [
                  ...newPanes,
                  {
                    label: 'Đơn hàng gán gói',
                    children: '',
                    key: 'order-assigned-package/list',
                    closable: true,
                  },
                ],
              }),
            );
          }
          navigate(`/management/order-assigned-package/list`);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const renderTypePackage = () => {
    switch (form.getFieldValue('type')) {
      case 'RegisterPackage':
        return <div>Gán gói</div>;
      case 'ActiveSingle':
        return <div>Đấu nối đơn lẻ</div>;
      case 'ActiveLot':
        return <div>Đấu nối theo lô</div>;
      case 'ChangeSim':
        return <div>Đổi sim</div>;

      default:
        return <div>Gán gói</div>;
    }
  };

  const handleRetryKitting = async () => {
    if (id) {
      try {
        const res = await retryPackageAssigned({
          orderId: id,
          updatedBy: merchantInfo ? JSON.parse(merchantInfo).merchantName : '',
        });
        if (res) {
          let isStatusKitting = false;
          if (res.statusString === OrderStatusEnum.Completed) {
            isStatusKitting = true;
          }
          if (isStatusKitting) {
            message.success('Retry gán gói thành công');
            dispatch(setGlobalState({ refresh: !refresh }));
          } else {
            message.error('Retry gán gói thất bại');
            dispatch(setGlobalState({ refresh: !refresh }));
          }
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleChangeMbfCode = async () => {
    if (dataSuccess.length > 0 || dataFailed.length > 0) {
      try {
        const checkOldData: string[] = [];
        dataSuccess.forEach((item) => {
          if (item.serial) {
            checkOldData.push(item.serial);
          }
        });
        dataFailed.forEach((item) => {
          if (item.serial) {
            checkOldData.push(item.serial);
          }
        });
        const res = await checkMbfCodePackageAssigned({
          mbfCode: form.getFieldValue('mbfCode') ?? '',
          serials: checkOldData,
          distributorId: merchantInfo ? JSON.parse(merchantInfo).merchantId : '',
          orderId: id,
          simType: simType,
        });
        if (res) {
          dispatch(
            setPackageAssignedState({
              dataSuccess: res.simSuccess ?? [],
              dataFailed: res.simError ?? [],
            }),
          );
          setInfoPackageInput({ mbfCode: res.mbfCode, price: res.price, mbfName: res.mbfName });
          if (res.simSuccess.length > 0) {
            message.success('Danh sách sim phù hợp với gói!');
          } else {
            message.error('Danh sách sim không phù hợp với gói!');
          }
        }
      } catch (error) {
        form.setFieldValue('mbfCode', order?.mbfCode);
      }
    }
    setOpenModalConfirmChange(false);
  };

  const handleCancel = async () => {
    try {
      const res = await cancelPackageAssigned(id);
      if (res) {
        setOpenModalConfirmCancel(false);
        dispatch(setGlobalState({ refresh: !refresh }));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handlePrePayment = async () => {
    if (id) {
      if (order?.simType === SimType.ESIM) {
        try {
          await checkEsimExpired(id).then((res) => {
            if (res?.esimExpired?.length > 0) {
              setIsOpenModalCheckEsimExpired(true);
              setListEsimExpired(res?.esimExpired);
              setListEsimValid(res?.esimValid);
            } else if (res?.esimExpired?.length <= 0 && res?.esimValid?.length > 0) {
              onClickConfirmEsimExpired();
            }
          });
        } catch (error: any) {
          console.log(error);
        }
      } else {
        onClickConfirmEsimExpired();
      }
    } else {
      console.log('error');
    }
  };

  const onClickConfirmEsimExpired = () => {
    dispatch(
      setGlobalState({
        refresh: !refresh,
      }),
    );
    setIsOpenModalCheckEsimExpired(false);
    dispatch(
      setModalState({
        open: true,
        content: 'billing-info',
        width: size.width <= 768 ? '95%' : '50%',
      }),
    );
  };

  const onCancelEsimExpired = () => {
    setIsOpenModalCheckEsimExpired(false);
    dispatch(
      setGlobalState({
        refresh: !refresh,
      }),
    );
  };

  const confirmReloadData = (callbackOk?: any, callbackCancel?: any) => {
    if (dataSuccess.length || dataFailed.length) {
      Modal.confirm({
        title: 'Xác nhận',
        icon: <ExclamationCircleOutlined />,
        content: 'Bạn có muốn xoá dữ liệu và thực hiện lại?',
        okText: 'Tiếp tục',
        cancelText: 'Huỷ',
        onOk: () => {
          dispatch(
            setPackageAssignedState({
              dataSuccess: [],
              dataFailed: [],
            }),
          );
          typeof callbackOk === 'function' && callbackOk();
        },
        onCancel: () => {
          typeof callbackCancel === 'function' && callbackCancel();
        },
      });
    } else {
      typeof callbackOk === 'function' && callbackOk();
    }
  };

  const handleExportTemplate = () => {
    const link = document.createElement('a');
    link.target = '_blank';
    link.download = `mau_import_sim.xlsx`;
    const url = process.env.REACT_APP_API_URL + '/api/Provider/export-excel-template?type=2';
    exportExcel(url)
      .then((res) => {
        link.href = URL.createObjectURL(new Blob([res.data], { type: 'application/vnd.ms-excel' }));
        link.click();
      })
      .catch((error) => {
        if (error.status === 403) {
          message.error(`Tài khoản của bạn không có quyền truy cập vào chức năng này`);
        }
      });
  };

  return (
    <Fragment>
      <div className='flex justify-between'>
        <div className='row-button justify-end mb-[1.5rem] flex-wrap gap-y-4'>
          {hasPermission(PERMISSIONS.ASSIGN_PACKAGE.CANCEL) && (
            <Button
              type='dashed'
              disabled={order?.statusString === OrderStatusEnum.PAYMENT_FAIL ? false : true}
              onClick={() => setOpenModalConfirmCancel(true)}
            >
              Huỷ
            </Button>
          )}

          {hasPermission(PERMISSIONS.ASSIGN_PACKAGE.RETRY) && (
            <Button
              disabled={order?.statusString === OrderStatusEnum.Uncompleted ? false : true}
              onClick={handleRetryKitting}
            >
              Retry
            </Button>
          )}

          {hasPermission(PERMISSIONS.ASSIGN_PACKAGE.ASSIGN) && (
            <Button
              type='primary'
              disabled={order?.statusString === OrderStatusEnum.Paid ? false : true}
              onClick={() => setOpenModalConfirmKitting(true)}
            >
              Gán gói
            </Button>
          )}

          {hasPermission(PERMISSIONS.ASSIGN_PACKAGE.PAYMENT) && (
            <Button
              type='primary'
              disabled={
                (order?.statusString === OrderStatusEnum.New && listEsimValid?.length > 0) ||
                (statusSim === OrderStatusEnum.PAYMENT_FAIL && order?.statusString)
                  ? false
                  : true
              }
              onClick={() => {
                if (dataSuccess.length > 0) {
                  handlePrePayment();
                } else {
                  message.error('Danh sách SIM gán gói rỗng');
                }
              }}
            >
              Thanh toán
            </Button>
          )}

          {hasPermission(PERMISSIONS.ASSIGN_PACKAGE.UPDATE) && (
            <Button
              disabled={statusSim === OrderStatusEnum.New && id ? false : true}
              onClick={() => setStatusSim(OrderStatusEnum.EDIT)}
            >
              Sửa
            </Button>
          )}

          {hasAnyPermission(
            PERMISSIONS.ASSIGN_PACKAGE.CREATE,
            PERMISSIONS.ASSIGN_PACKAGE.UPDATE,
          ) && (
            <Button
              type='primary'
              loading={isLoading}
              onClick={async () => {
                if (dataSuccess.length > 0) {
                  form.validateFields(['mbfCode']).then(() => {
                    handleSubmit();
                  });
                } else {
                  message.error('Danh sách SIM gán gói rỗng');
                }
                setIsLoading(true);
                setTimeout(() => {
                  setIsLoading(false);
                }, 3000);
              }}
              disabled={
                statusSim === OrderStatusEnum.EDIT || (statusSim === OrderStatusEnum.New && !id)
                  ? false
                  : true
              }
            >
              Lưu
            </Button>
          )}

          {hasPermission(PERMISSIONS.ASSIGN_PACKAGE.DELETE) && (
            <Button
              disabled={statusSim === OrderStatusEnum.New && id ? false : true}
              onClick={() => setOpenModalConfirmDelete(true)}
              danger
              type='primary'
            >
              Xóa
            </Button>
          )}
        </div>
      </div>
      <BoxWithLabel title='Thông tin đơn hàng' classNames='mb-[1.5rem]'>
        <Form
          className='[&_.ant-form-item-label>label]:font-bold [&_.ant-form-item-label>label]:md:font-normal'
          form={form}
        >
          <Row gutter={24}>
            <Col span={24} md={12} lg={7}>
              <Form.Item
                className='ant-label-flex-wrap'
                labelCol={{ span: 12 }}
                label={<div className='text-wrap'>Mã đơn</div>}
                name={'id'}
              >
                {form.getFieldValue('id')}
              </Form.Item>
              <Form.Item
                className='ant-label-flex-wrap'
                labelCol={{ span: 12 }}
                label={<div className='text-wrap'>Loại đơn hàng</div>}
                name={'type'}
              >
                {renderTypePackage()}
              </Form.Item>
              <Form.Item
                className='ant-label-flex-wrap'
                label={<div className='text-wrap'>Loại SIM</div>}
                labelCol={{ span: 12 }}
                rules={[{ required: true, message: 'Vui lòng chọn loại SIM' }]}
                name='simType'
              >
                <Select
                  showSearch
                  placeholder='Vui lòng chọn'
                  defaultValue={SimType.PHYSICAL_SIM}
                  options={[
                    {
                      value: SimType.PHYSICAL_SIM,
                      label: simTypeToText(SimType.PHYSICAL_SIM),
                    },
                    {
                      value: SimType.ESIM,
                      label: simTypeToText(SimType.ESIM),
                    },
                  ]}
                  disabled={statusSim === OrderStatusEnum.New && !id ? false : true}
                  onChange={(value) => {
                    setSimType(value);
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={24} md={12} lg={5}>
              <Form.Item
                className='ant-label-flex-wrap'
                label={<div className='text-wrap'>Tổng cộng</div>}
                labelCol={{ span: 12 }}
                name='countSerial'
              >
                {form.getFieldValue('countSerial')}
              </Form.Item>
              <Form.Item
                className='ant-label-flex-wrap'
                label={<div className='text-wrap'>Thành công</div>}
                labelCol={{ span: 12 }}
                name='quantitySuccess'
              >
                {form.getFieldValue('quantitySuccess')}
              </Form.Item>
              <Form.Item
                className='ant-label-flex-wrap'
                label={<div className='text-wrap'>Thất bại</div>}
                labelCol={{ span: 12 }}
                name='quantityFailed'
              >
                {form.getFieldValue('quantityFailed')}
              </Form.Item>
            </Col>
            <Col span={24} md={12} lg={6}>
              <Form.Item
                className='ant-label-flex-wrap'
                label={<div className='text-wrap'>Thành tiền</div>}
                labelCol={{ span: 12 }}
                name='toTalAmount'
              >
                {form.getFieldValue('toTalAmount')
                  ? formatMoney(form.getFieldValue('toTalAmount'), 'đ')
                  : ''}
              </Form.Item>
              <Form.Item
                className='ant-label-flex-wrap truncate'
                label={<div className='text-wrap'>Mã GD thanh toán</div>}
                labelCol={{ span: 12, lg: { span: 15 } }}
                name='transactionId'
              >
                {form.getFieldValue('transactionId') && (
                  <div
                    className='text-blue-600 underline cursor-pointer'
                    onClick={() =>
                      dispatch(
                        setModalState({
                          open: true,
                          content: 'billing-info',
                          width: size.width <= 768 ? '95%' : '50%',
                        }),
                      )
                    }
                  >
                    <span>{form.getFieldValue('transactionId')}</span>
                  </div>
                )}
              </Form.Item>
              <Form.Item
                className='ant-label-flex-wrap'
                label={<div className='text-wrap'>Trạng thái</div>}
                labelCol={{ span: 12 }}
                initialValue={''}
                name='statusString'
              >
                {form.getFieldValue('statusString')}
              </Form.Item>
            </Col>
            <Col span={24} md={12} lg={6}>
              <Form.Item
                className='ant-label-flex-wrap'
                label={<div className='text-wrap'>Người tạo</div>}
                labelCol={{ span: 12 }}
                name='createdBy'
              >
                {form.getFieldValue('createdBy')}
              </Form.Item>
              <Form.Item
                className='ant-label-flex-wrap'
                label={<div className='text-wrap'>Thời gian tạo</div>}
                labelCol={{ span: 12 }}
                name='createdAt'
                valuePropName={
                  form.getFieldValue('createdAt')
                    ? formatDateTime(form.getFieldValue('createdAt'))
                    : ''
                }
              >
                {form.getFieldValue('createdAt')
                  ? formatDateTime(form.getFieldValue('createdAt'))
                  : ''}
              </Form.Item>
              <Form.Item
                className='ant-label-flex-wrap'
                label={<div className='text-wrap'>Người cập nhật gần nhất</div>}
                labelCol={{ span: 12, className: 'overflow-visible text-wrap' }}
                name='updatedBy'
              >
                {form.getFieldValue('updatedBy')}
              </Form.Item>
              <Form.Item
                className='ant-label-flex-wrap'
                label={<div className='text-wrap'>Ngày cập nhật gần nhất</div>}
                labelCol={{ span: 12 }}
                name='updatedAt'
              >
                {form.getFieldValue('updatedAt')
                  ? new Date(form.getFieldValue('updatedAt')).getTime() ===
                    new Date(form.getFieldValue('createdAt')).getTime()
                    ? ''
                    : formatDateTime(form.getFieldValue('updatedAt'))
                  : ''}
              </Form.Item>
            </Col>

            <Col span={24} md={16} lg={12}>
              <Form.Item
                className='ant-label-flex-wrap'
                label={<div className='text-wrap'>Loại thuê bao</div>}
                labelCol={{ span: 12, md: { span: 9 }, lg: { span: 7 } }}
                rules={[{ required: true, message: 'Vui lòng chọn loại thuê bao' }]}
                name='subType'
              >
                <Select
                  showSearch
                  placeholder='Vui lòng chọn'
                  options={renderOptionSubType()}
                  disabled={statusSim === OrderStatusEnum.EDIT || id ? true : false}
                  onChange={async (value) => {
                    if (value) {
                      if (!id) {
                        fetchGetPackageAssigned(value);
                        form.setFieldValue('mbfCode', '');
                      } else {
                        setOpenModalConfirmChangeCosType(true);
                      }
                    }
                  }}
                />
              </Form.Item>
              <Form.Item
                className='ant-label-flex-wrap'
                label={<div className='text-wrap'>Gói</div>}
                labelCol={{ span: 12, md: { span: 9 }, lg: { span: 7 } }}
                rules={[{ required: true, message: 'Vui lòng chọn gói' }]}
                name='mbfCode'
              >
                <Select
                  showSearch
                  placeholder='Vui lòng chọn'
                  options={dataPackage}
                  optionLabelProp='shortLabel'
                  disabled={
                    statusSim === OrderStatusEnum.EDIT ||
                    (statusSim === OrderStatusEnum.New && !id) ||
                    !simType
                      ? false
                      : true
                  }
                  popupClassName='w-[320px] md:w-[500px]'
                  dropdownMatchSelectWidth={false}
                  onChange={() => {
                    if (dataSuccess.length > 0 || dataFailed.length > 0) {
                      setOpenModalConfirmChange(true);
                    }
                  }}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16} className='mb-[1rem]'>
            <Col span={24}>
              <Radio.Group
                onChange={(e: RadioChangeEvent) => {
                  confirmReloadData(
                    () => {
                      form.resetFields(['serial', 'countSerialNumber']);
                      setFile(null);
                      setRadio(e.target.value);
                    },
                    () => {
                      setRadio(e.target.value);
                    },
                  );
                }}
                disabled={
                  statusSim === OrderStatusEnum.EDIT || (statusSim === OrderStatusEnum.New && !id)
                    ? false
                    : true
                }
                value={radio}
              >
                <Radio value={1}>Nhập serial</Radio>
                {hasPermission(PERMISSIONS.ASSIGN_PACKAGE.IMPORT_EXCEL) && (
                  <Radio value={2}>Import file</Radio>
                )}
              </Radio.Group>
            </Col>
          </Row>

          <Row gutter={[16, 16]}>
            {radio === 1 ? (
              <>
                <Col span={24} lg={7}>
                  <Form.Item
                    className='ant-label-flex-wrap'
                    labelCol={{ span: 12, md: { span: 6 }, lg: { span: 12 } }}
                    name='serial'
                    rules={[
                      {
                        required: true,
                        message: 'Vui lòng nhập số serial',
                      },
                      {
                        min: 16,
                        message: 'Vui lòng nhập đủ số serial',
                      },
                    ]}
                    label={<div className='text-wrap'>Số serial</div>}
                  >
                    <Input
                      type='number'
                      maxLength={20}
                      onChange={(e) => {
                        if (e.target.value.length <= 20) {
                          form.setFieldValue('serial', e.target.value);
                        } else {
                          form.setFieldValue('serial', e.target.value.substring(0, 20));
                        }
                        e.preventDefault();
                      }}
                      onKeyDown={(evt) => {
                        if (!evt.ctrlKey && !evt.metaKey) {
                          if (
                            evt.key === 'e' ||
                            (!isFinite(Number(evt.key)) && evt.key !== 'Backspace') ||
                            evt.key === '+' ||
                            evt.key === '-' ||
                            evt.key === '.' ||
                            Number(evt.key) > 9 ||
                            Number(evt.key) < 0
                          ) {
                            evt.preventDefault();
                          }
                        }
                      }}
                      disabled={
                        statusSim === OrderStatusEnum.EDIT ||
                        (statusSim === OrderStatusEnum.New && !id)
                          ? false
                          : true
                      }
                    />
                  </Form.Item>
                </Col>
                <Col span={15} md={20} lg={6}>
                  <Form.Item
                    className='ant-label-flex-wrap'
                    label={<div className='text-wrap'>Số lượng</div>}
                    labelCol={{ span: 7, lg: { span: 10 } }}
                    name='countSerialNumber'
                    rules={[
                      { required: true, message: 'Vui lòng nhập số lượng' },
                      { max: 1000, message: 'Vượt quá số lượng cho phép.' },
                    ]}
                  >
                    <Input
                      type={'number'}
                      onKeyDown={(evt) => {
                        if (!evt.ctrlKey && !evt.metaKey) {
                          if (
                            evt.key === 'e' ||
                            (!isFinite(Number(evt.key)) && evt.key !== 'Backspace') ||
                            evt.key === '+' ||
                            evt.key === '.' ||
                            evt.key === '-' ||
                            Number(evt.key) > 9 ||
                            Number(evt.key) < 0
                          ) {
                            evt.preventDefault();
                          }
                        }
                      }}
                      maxLength={5}
                      disabled={
                        statusSim === OrderStatusEnum.EDIT ||
                        (statusSim === OrderStatusEnum.New && !id)
                          ? false
                          : true
                      }
                      onChange={(value) => onChangeCountSerialNumber(value)}
                    />
                  </Form.Item>
                </Col>

                <Button
                  onClick={() => {
                    form
                      .validateFields(['serial', 'countSerialNumber'])
                      .then(() => {
                        if (radio === 1) {
                          handleAddInput();
                        } else {
                          setOpenModalConfirm(true);
                        }
                      })
                      .catch((error) => {
                        console.log(error);
                      });
                  }}
                  disabled={
                    statusSim === OrderStatusEnum.EDIT || (statusSim === OrderStatusEnum.New && !id)
                      ? false
                      : true
                  }
                  className='mt-10 md:mt-0'
                >
                  Thêm
                </Button>
              </>
            ) : (
              <>
                <div className='flex gap-4 md:ml-2 flex-wrap'>
                  {!file && order && order.fileUrl && (
                    <a href={order?.fileUrl} download>
                      <Button
                        type='link'
                        className='[&_span]:break-words [&_span]:max-w-[200px] [&_span]:whitespace-pre-wrap [&_span]:md:max-w-none'
                      >
                        {order?.fileName || 'Excel file'}
                      </Button>
                    </a>
                  )}
                  <Upload
                    {...propsUpload}
                    maxCount={1}
                    accept='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    showUploadList
                    fileList={file ? [file] : []}
                    className='[&_.ant-upload-list-item.ant-upload-list-item-done]:flex-wrap [&_.ant-upload-list-item.ant-upload-list-item-done]:h-fit [&_.ant-upload-list-item-name]:whitespace-pre-wrap [&_.ant-upload-list-item-name]:max-w-[200px] md:[&_.ant-upload-list-item-name]:max-w-none [&_.ant-upload-list-item-name]:p-0 md:[&_.ant-upload-list-item-name]:p-2 [&_.ant-upload-list-item-name]:break-words'
                  >
                    <Button
                      className={!file && order && order.fileUrl ? 'ml-2' : 'ml-2 md:ml-0'}
                      type='dashed'
                      disabled={
                        statusSim === OrderStatusEnum.EDIT ||
                        (statusSim === OrderStatusEnum.New && !id)
                          ? false
                          : true
                      }
                    >
                      Chọn File
                    </Button>
                  </Upload>
                </div>

                {hasPermission(PERMISSIONS.ASSIGN_PACKAGE.IMPORT_EXCEL) && (
                  <Button
                    className={'ml-2'}
                    type='primary'
                    onClick={handleImport}
                    disabled={
                      (file && watchCode && statusSim === OrderStatusEnum.EDIT) ||
                      (statusSim === OrderStatusEnum.New && !id && file)
                        ? false
                        : true
                    }
                  >
                    Import
                  </Button>
                )}

                {hasPermission(PERMISSIONS.ASSIGN_PACKAGE.EXPORT_TEMPLATE) && (
                  <Button className='ml-2' onClick={() => handleExportTemplate()}>
                    Export template
                  </Button>
                )}
              </>
            )}
          </Row>
        </Form>
      </BoxWithLabel>
      <BoxWithLabel classNames='mb-10 lg:mb-0' title='Danh sách SIM gán gói'>
        <Tabs type='card' items={items} />
      </BoxWithLabel>
      <ModalConfirm
        open={openModalConfirm}
        content={
          <div className='pb-0 p-8'>
            <div className='font-black text-3xl mb-4'>Bạn chắc chưa?</div>
            <p>Sau khi thêm sẽ xóa dữ liệu trước đó</p>
            <div className='flex flex-col md:flex-row gap-4 h-[54px] w-full mt-12 mb-16 md:mb-0'>
              <Button
                onClick={() => {
                  if (radio === 1) {
                    handleAddInput(true);
                  } else {
                    handleImport();
                  }
                }}
                className='h-full w-full'
              >
                XÁC NHẬN
              </Button>
              <Button
                className='h-full w-full'
                onClick={() => {
                  setOpenModalConfirm(false);
                }}
              >
                THOÁT
              </Button>
            </div>
          </div>
        }
      />
      <ModalConfirm
        open={openModalConfirmKitting}
        content={
          <div className='pb-0 p-8'>
            <div className='font-black text-3xl mb-4'>Gán gói?</div>
            <p>Bạn có chắc chắn muốn gán gói đơn hàng này?</p>
            <div className='flex flex-col md:flex-row gap-4 h-[54px] w-full mt-12 mb-16 md:mb-0'>
              <Button
                onClick={handleKittingSim}
                className='h-full w-full'
                disabled={isLoadingModal}
              >
                XÁC NHẬN
              </Button>
              <Button
                className='h-full w-full'
                onClick={() => {
                  setOpenModalConfirmKitting(false);
                }}
              >
                THOÁT
              </Button>
            </div>
          </div>
        }
      />

      <ModalConfirm
        open={openModalConfirmDelete}
        content={
          <div className='pb-0 p-8'>
            <div className='font-black text-3xl mb-4'>Xoá đơn hàng?</div>
            <p>Bạn có chắc chắn muốn xoá đơn hàng gán gói này?</p>
            <div className='flex flex-col md:flex-row gap-4 h-[54px] w-full mt-12 mb-16 md:mb-0'>
              <Button onClick={handleDeleteOrder} className='h-full w-full'>
                XÁC NHẬN
              </Button>
              <Button
                className='h-full w-full'
                onClick={() => {
                  setOpenModalConfirmDelete(false);
                }}
              >
                THOÁT
              </Button>
            </div>
          </div>
        }
      />
      <ModalConfirm
        open={openModalConfirmChange}
        content={
          <div className='pb-0 p-8'>
            <div className='font-black text-3xl mb-4'>Đổi gói?</div>
            <p>
              Danh sách SIM có thể không còn phù hợp với gói mà bạn muốn thay đổi. Bạn có muốn thực
              hiện?
            </p>
            <div className='flex flex-col md:flex-row gap-4 h-[54px] w-full mt-12 mb-16 md:mb-0'>
              {hasPermission(PERMISSIONS.ASSIGN_PACKAGE.CHECK_SERIALS) && (
                <Button onClick={handleChangeMbfCode} className='h-full w-full'>
                  XÁC NHẬN
                </Button>
              )}
              <Button
                className='h-full w-full'
                onClick={() => {
                  form.setFieldValue(
                    'mbfCode',
                    infoPackageInput?.mbfCode ? infoPackageInput?.mbfCode : order?.mbfCode,
                  );
                  setOpenModalConfirmChange(false);
                }}
              >
                THOÁT
              </Button>
            </div>
          </div>
        }
      />
      <ModalConfirm
        open={openModalConfirmCancel}
        content={
          <div className='pb-0 p-8'>
            <div className='font-black text-3xl mb-4'>Huỷ đơn hàng?</div>
            <p>Bạn có muốn thực hiện thay đổi?</p>
            <div className='flex flex-col md:flex-row gap-4 h-[54px] w-full mt-12 mb-16 md:mb-0'>
              <Button onClick={handleCancel} className='h-full w-full'>
                XÁC NHẬN
              </Button>
              <Button
                className='h-full w-full'
                onClick={() => {
                  form.setFieldValue('mbfCode', order?.mbfCode);
                  setOpenModalConfirmCancel(false);
                }}
              >
                THOÁT
              </Button>
            </div>
          </div>
        }
      />
      {isOpenModalCheckEsimExpired && (
        <ModalCheckEsimExpired
          isOpen={isOpenModalCheckEsimExpired}
          setIsOpenModal={setIsOpenModalCheckEsimExpired}
          listEsimExpired={listEsimExpired}
          listEsimValid={listEsimValid}
          onClickConfirm={onClickConfirmEsimExpired}
          onClickCancel={onCancelEsimExpired}
        />
      )}
    </Fragment>
  );
}

export default CreateOrderPage;
